import { ComponentType, PropsWithChildren, useEffect, useState } from "react";
import GapFillStatusEnum from "@app/projects/network-assessment/adequacy/gapFillStatusEnum";
import ProjectService from "@app/projects/projectService";
import { GapFillStatusDescriptionMap } from "@app/projects/network-assessment/adequacy/gapFillStatusDescriptionMap";

export interface GapFillStatusDescriptionProps {
    gapFillStatusDescriptionMap: GapFillStatusDescriptionMap;
}

const gapFillStatusEmptyDescriptions: GapFillStatusDescriptionMap = {
    [GapFillStatusEnum.gapFilled]: '---',
    [GapFillStatusEnum.none]: '---',
    [GapFillStatusEnum.researching]: '---',
    [GapFillStatusEnum.contractingGapClosure]: '---',
    [GapFillStatusEnum.contractingExceptionEligible]: '---',
    [GapFillStatusEnum.exceptionRequired]: '---',
    [GapFillStatusEnum.rppoWaiverRequired]: '---',
    [GapFillStatusEnum.availableEntitiesWillNotContract]: '---',
}

const useGapFillStatusDescriptions = (): GapFillStatusDescriptionMap => {    
    const [gapFillStatusDescriptions, setGapFillStatusDescriptions] = useState<GapFillStatusDescriptionMap>(gapFillStatusEmptyDescriptions);

    useEffect(() => {
        const getGapFillStatusDescriptions = async () => {            
            const projectService = new ProjectService();
            const descriptions = await projectService.getGapFillStatusDescriptions();
            descriptions[GapFillStatusEnum.none] = '---';
            setGapFillStatusDescriptions(descriptions);
        }
        getGapFillStatusDescriptions();
    }, []);

    return gapFillStatusDescriptions;
}

export default useGapFillStatusDescriptions;

export function withGapFillStatusDescriptions<T>(Component: ComponentType<PropsWithChildren<T & GapFillStatusDescriptionProps>>): ComponentType<PropsWithChildren<T>> {
    return function WrappedComponent(props) {
        const descriptions = useGapFillStatusDescriptions();
        return <Component {...props} {...{['gapFillStatusDescriptionMap']: descriptions}} />;
    }
}